import React from 'react';
import ReportCharts from './ReportCharts';
import ReportDataView from './ReportDataView';

// Renders a report as either heavy charts or a sortable data (table) view.
export default function ReportBody({ type, data, view }) {
  return view === 'data'
    ? <ReportDataView type={type} data={data} />
    : <ReportCharts type={type} data={data} />;
}
